export default {_name:'card.simple',module:'Field',view:'Element/Card',webOptions:{sm:3,xs:12},mobileOptions:{ms:3}}